import { FC, ReactNode } from 'react';
// mui components
import { Grid, Typography, CircularProgress } from '@mui/material';
// styles
import { styles } from '../styles/styles';

interface IProps {
  isLoading: boolean;
  isEmpty: boolean;
  isError: boolean;
  children: ReactNode;
}

export const ContentWrapper: FC<IProps> = ({
  children,
  isEmpty,
  isError,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <Grid sx={styles.loaderContainer}>
        <CircularProgress />
      </Grid>
    );
  }

  if (isError) {
    return (
      <Grid sx={styles.emptyStateContainer}>
        <Typography sx={styles.emptyStateTitle}>Something went wrong</Typography>
      </Grid>
    );
  }

  if (isEmpty) {
    return (
      <Grid sx={styles.emptyStateContainer}>
        <Typography sx={styles.emptyStateTitle}>No Activity</Typography>
        <Typography sx={styles.emptyStateSubtitle}>Looks like you have no activity yet</Typography>
      </Grid>
    );
  }

  return <>{children}</>;
};
